module.exports = __webpack_public_path__ + "img/34905f8.png";